//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from "@/components/50.wisdomMini/Card/index.vue";
import FooterBox from "@/components/50.wisdomMini/FooterBox/index.vue";

export default {
  components: {
    card,
    FooterBox
  },

  data() {
    return {
      isinfor: false,
      passageUserinfor: "",
      isLogin: false,
      loginConfig: {
        IsShow: false
      },
      passageUser: {},
      passageMiniFans: {},
      isIpx: false,
      cards: [
        {
          title: "我的信息",
          list: [
            {
              icon: "guishu",
              iconDesc: "我的归属",
              source: "user",
              // webUrl: "/mSms/PassageNode/BelongTo",
              routeName: "/SmartGms/MyInfo/Detail?openId=123344",
              parameter: "OpenId"
            },
            {
              icon: "mendianhuodong",
              iconDesc: "门店资料",
              source: "user",
              // webUrl: "/mSms/PassageNode/Info"
              routeName: "/SmartGms/ShopInfo/Detail?openId=123344",
              parameter: "PassageNodeShopId"
            },
            {
              icon: "mendianrenzheng",
              iconDesc: "门店认证",
              source: "user",
              routeName: "/SmartGms/PassageUserCertify/Edit?openId=1"
            },
            {
              icon: "shenfenrenzheng",
              iconDesc: "身份证认证",
              source: "user",
              routeName: "/SmartGms/IdentityCardCertify/Edit?openId=1"
            },
            {
              icon: "shenfenrenzheng",
              iconDesc: "银行卡认证",
              source: "user",
              routeName: "/SmartGms/BankCertify/Edit?openId=1"
            },
            {
              icon: "mendianerweima",
              iconDesc: "门店二维码",
              source: "user",
              //webUrl: "/SmartGms/ShopInfo/Detail?openId=ShopQr"
              routeName: "/SmartGms/ShopInfo/Detail?openId=ShopQr"
              // parameter: "PassageNodeShopId"
            },
            {
              icon: "shouhou",
              iconDesc: "我的售后",
              source: "user"
            },
            {
              icon: "shoucang",
              iconDesc: "我的收藏",
              source: "user",
              webUrl: "/mSms/QrCode/Index"
              // routeName:
              //   "/pages/ToSubcontractD/pages/10_Kbms/PassageUserCollect/main"
            },
            {
              icon: "qrcode",
              iconDesc: "我的二维码",
              source: "user",
              routeName: "/SmartGms/QrCode/Detail?openId=QrCode"
            },
            {
              icon: "dingwei",
              iconDesc: "位置纠错",
              routeName: "/SmartGms/PassageNodeReviseGps/Index",
              source: "user"
            },
            {
              icon: "jilu",
              iconDesc: "纠错记录",
              // routeName: "/pages/99.Tpl/Cs/01.Index/main",
              source: "user"
            }
            //  {
            //   icon: "funeng@2x",
            //   iconDesc: "赋能工具",
            //   routeName: "/pages/ToSubcontractA/pages/02_Mms/MemberTargetGroup/main",
            //   source: "user"
            // }
          ]
        },
        {
          title: "导购考勤",
          list: [
            {
              icon: "daka",
              iconDesc: "打卡",
              routeName: "/SmartGms/WorkClockInOrder/Create",
              source: "user"
            },
            {
              icon: "paiban",
              iconDesc: "排班",
              routeName: "/SmartGms/PassageUserWeekPlanOrder/Index",
              source: "user"
            },
            {
              icon: "tiaoban",
              iconDesc: "调班",
              routeName: "/SmartGms/PassageUserCheckWeekPlanOrder/Index",
              source: "user"
            },
            {
              icon: "tongji",
              iconDesc: "考勤记录",
              routeName: "/SmartGms/WorkClockInOrder/Index",
              source: "user"
            }
          ]
        },
        {
          title: "系统设置",
          list: [
            {
              icon: "lizhi",
              iconDesc: "离职申请",
              source: "user",
              routeName: "/SmartGms/GuidePassageUserLeave/Index"
            },
            {
              img: "images/31_11.png",
              text: "数据看板",
              routeName: "/YslSms/Datakanban/Index"
            },
            {
              icon: "jiebang",
              iconDesc: "解除绑定",
              source: "user"
              // routeName: "/pages/ToSubcontractC/pages/09_Cm/UnBind/Create/main"
            },
            {
              icon: "zhuxiao",
              iconDesc: "系统注销",
              source: "user"
              // webUrl: "/Help/Clear"
            },
            {
              icon: "cache",
              iconDesc: "清除缓存",
              source: "user"
              // cache: true
            }
            // {
            //   icon: "lizhi",
            //   iconDesc: "离职记录",
            //   source: "user",
            //    routeName:
            //     "/SmartGms/GuidePassageUserLeave/Index"
            // },
            // {
            //   icon: "lizhi",
            //   iconDesc: "入职记录",
            //   source: "user",
            //    routeName:
            //     "/SmartGms/GuidePassageUserLeave/Index"
            // },
          ]
        },
        {
          title: "帮助中心",
          list: [
            {
              icon: "shouce",
              iconDesc: "使用手册",
              source: "user"
              // webUrl: "/mCm/My/Video"
            },
            {
              icon: "fankui",
              iconDesc: "使用反馈",
              source: "user"
              // webUrl: "/mCm/Feedback/Create"
            },
            {
              icon: "xieyi",
              iconDesc: "服务协议"
              // source: "user",
              // webUrl:"/mSms/Protocol/Info",
              // routeName:
              //   "/pages/ToSubcontractA/pages/01_Workbench/Services/main"
            },
            {
              icon: "banben",
              iconDesc: "版本信息",
              source: "user"
            }
          ]
        }
      ],
      countData: [
        {
          name: "积分",
          count: 0
        },
        {
          name: "佣金",
          count: 0
        },
        {
          name: "消息",
          count: 0
          // LinkUrl:
          //   "/pages/ToSubcontractA/pages/01_Workbench/04_My/Alert/Index/main"
        }
      ]
    };
  },
  created() {
    this.passageUserinfor = this.$appBox.getPassageUser();
    if (this.$appBox.getPassageUser()) {
      this.isinfor = true;
    } else {
      this.isinfor = false;
    }
  },
  computed: {},
  onLoad: function() {
    console.log("onLoad==========", this.passageMiniFans);
    // 隐藏原生的tabbar
   
    var that = this;
    

    console.log("this.$appBox.isLogin()", this.$appBox.isLogin());

    this.loadBoardData();
  },
  onShow() {
    console.log("onShow---this.$appBox.isLogin()", this.$appBox.isLogin());
    this.loadBoardData();
  },

  mounted() {
    
  },
  methods: {
    alertLogin() {
      //this.$msg.alert("您还未登录，请登录系统，绑定身份后使用.");
      this.loginConfig.IsShow = true;
      return;
    },

    onPopupLoginAction(isOk) {},

    doLogin() {
      this.loginConfig.IsShow = true;
      //this.$msg.alert("===========弹出登录界面=.");
      return;
    },

    loadBoardData() {
      this.isLogin = this.$appBox.isLogin();
      if (this.isLogin) {
        this.passageMiniFans = this.$appBox.getPassageMiniFans();
        this.passageUser = this.$appBox.getPassageUser();
      }

      if (this.isLogin) {
        //新增会员
        this.countData[0].count = this.passageUser.Points;
        this.countData[1].count = this.passageUser.Money;
        this.countData[2].count = 0;
      }
    },
    ClickNews(Item) {
      if (Item.LinkUrl) {
        this.$path.to(Item.LinkUrl);
      }
    }
  }
};
